// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__HmelI","title":"ClientReferral_title__22U-G","itemText":"ClientReferral_itemText__3dDrm"};